import { useState } from "react";
import styled from "styled-components";
import ProductCard from "../../../components/cards/ProductCard";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  margin: 0px 40px;

  @media (max-width: 950px) {
    margin: 120px 20px;
  }
`;

const TabsWrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  cursor: pointer;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

const Tab = styled.span`
  position: relative;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  letter-spacing: 0.1rem;
  text-transform: capitalize;
  color: ${colors.black};
  font-size: ${fontSize.xs};

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${colors.black};
    transform: translateX(-50%) scaleX(${(props) => (props.active ? 1 : 0)});
    transform-origin: center;
    transition: transform 0.3s ease;
  }

  &:hover::after {
    transform: translateX(-50%) scaleX(1);
  }
`;

const ItemsContainer = styled.div`
  display: grid;
  row-gap: 16px;
  column-gap: 4px;
  margin: 24px 0px;
  grid-template-columns: repeat(4, minmax(0px, 1fr));

  @media (max-width: 950px) {
    grid-template-columns: repeat(2, minmax(0px, 1fr));
  }
`;

const TABS_DATA = [
  {
    id: 0,
    label: "COMPLETE THE LOOK",
    products: [
      { id: 1, name: "Product 1" },
      { id: 2, name: "Product 2" },
      { id: 3, name: "Product 3" },
      { id: 4, name: "Product 4" },
    ],
  },
  {
    id: 1,
    label: "YOU MIGHT LIKE",
    products: [
      { id: 5, name: "Product 5" },
      { id: 6, name: "Product 6" },
    ],
  },
  {
    id: 2,
    label: "RECENTLY VIEWED",
    products: [
      { id: 7, name: "Product 7" },
      { id: 8, name: "Product 8" },
      { id: 9, name: "Product 9" },
    ],
  },
];

function RecommendationSection({ recommendedProducts }) {
  const [activeTab, setActiveTab] = useState(0);

  const currentTab = TABS_DATA.find((tab) => tab.id === activeTab);

  return (
    recommendedProducts.length > 0 && (
      <Wrapper>
        <TabsWrapper>
          {TABS_DATA.map((tab) => (
            <Tab
              key={tab.id}
              active={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </Tab>
          ))}
        </TabsWrapper>

        <ItemsContainer>
          {recommendedProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </ItemsContainer>
      </Wrapper>
    )
  );
}

export default RecommendationSection;
